module.exports = __webpack_public_path__ + "media/vue/assets/images/home/sephora-logo-14df5f19dfb5b6301a2ac10b1089d484.png";